import React, { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import styled from 'styled-components/macro';

import { CheckoutProvider } from '.';
import { useAuth } from '../context';
import { lazyWithPreload } from '../utilities/lazy-with-preload';
import { PromotionProvider } from './PromotionProvider';

const FramiProvider = lazyWithPreload(() =>
    import(/* webpackChunkName: 'FramiProvider' */ './FramiProvider').then((module) => ({
        default: module.FramiProvider,
    }))
);

const CompositionProvider = lazyWithPreload(() =>
    import(/* webpackChunkName: 'CompositionProvider' */ './CompositionProvider').then((module) => ({
        default: module.CompositionProvider,
    }))
);

const CompositionTemplateProvider = lazyWithPreload(() =>
    import(/* webpackChunkName: 'CompositionTemplateProvider' */ './CompositionTemplateProvider').then((module) => ({
        default: module.CompositionTemplateProvider,
    }))
);

const PriceProvider = lazyWithPreload(() =>
    import(/* webpackChunkName: 'PriceProvider' */ '.').then((module) => ({
        default: module.PriceProvider,
    }))
);

const ImagesProvider = lazyWithPreload(() =>
    import(/* webpackChunkName: 'ImagesProvider' */ '.').then((module) => ({
        default: module.ImagesProvider,
    }))
);

const AppContainer = styled.section`
    display: flex;
    flex-direction: column;
    background-color: #f5f5f5;
    height: 100%;
`;

export function FramkyProvider({ children }) {
    // const [searchParams] = useSearchParams();
    // const { login } = useAuth();

    useEffect(() => {
        // const token = searchParams.get('token');
        //
        // if (token) {
        //     localStorage.setItem('token', token);
        //     login(token);
        // }

        FramiProvider.preload();
        PriceProvider.preload();
        ImagesProvider.preload();
        CompositionTemplateProvider.preload();
        CompositionProvider.preload();
    }, []);

    return (
        <AppContainer>
            <FramiProvider>
                <PromotionProvider>
                    <PriceProvider>
                        <ImagesProvider>
                            <CompositionTemplateProvider>
                                <CompositionProvider>
                                    <CheckoutProvider>{children}</CheckoutProvider>
                                </CompositionProvider>
                            </CompositionTemplateProvider>
                        </ImagesProvider>
                    </PriceProvider>
                </PromotionProvider>
            </FramiProvider>
        </AppContainer>
    );
}
